import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState, useMemo, useCallback } from 'react';
import { get } from 'lodash-es';
/**
 * Complementary hooks for Antd Upload component
 * @param {Object} options
 * @param {Object[]} options.initialFiles
 * @param {String} options.initialFiles.name
 * @param {String} options.initialFiles.url
 */

var useFileUpload = function useFileUpload() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$initialFiles = _ref.initialFiles,
      initialFiles = _ref$initialFiles === void 0 ? [] : _ref$initialFiles;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      files = _useState2[0],
      setFiles = _useState2[1];

  var formattedInitialFiles = useMemo(function () {
    return initialFiles.map(function (file, fileIndex) {
      return {
        uid: "initial-file-".concat(fileIndex),
        name: file.name,
        url: file.url,
        status: 'done'
      };
    });
  }, [initialFiles]);
  var uploadProps = useMemo(function () {
    return {
      fileList: files.length > 0 ? files : formattedInitialFiles,
      beforeUpload: function beforeUpload(_, fileList) {
        var initialFileUids = formattedInitialFiles.map(function (initial) {
          return initial.uid;
        });
        setFiles(fileList.map(function (file) {
          return _objectSpread(_objectSpread({}, file), {}, {
            uid: file.uid,
            name: file.name,
            originFileObj: file,
            status: 'done'
          });
        }).filter(function (file) {
          return !initialFileUids.includes(file.uid);
        }));
        return false;
      },
      onRemove: function onRemove(file) {
        setFiles(function (currentFiles) {
          return currentFiles.filter(function (current) {
            return current.uid !== file.uid;
          });
        });
      }
    };
  }, [formattedInitialFiles, files]);
  var getFile = useCallback(function () {
    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return get(files, "[".concat(index, "].originFileObj"));
  }, [files]);
  var clearFiles = useCallback(function () {
    return setFiles([]);
  }, []);
  var getFileList = useCallback(function (variableName) {
    return _objectSpread(_defineProperty({}, variableName, files.map(function (_, fileIndex) {
      return String(fileIndex);
    })), files.map(function (file) {
      return get(file, 'originFileObj');
    }));
  }, [files]);
  var setFileList = useCallback(function () {
    var fileList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return setFiles(fileList.map(function (file, fileIndex) {
      return {
        uid: "manually-added-file-".concat(fileIndex),
        name: file.name,
        originFileObj: file,
        status: 'done'
      };
    }));
  }, []);
  return {
    files: files,
    uploadProps: uploadProps,
    getFile: getFile,
    getFileList: getFileList,
    clearFiles: clearFiles,
    setFileList: setFileList
  };
};

export default useFileUpload;